import fr from './fr.json'
import en from './en.json'
import es from './es.json'
import nl from './nl.json'
import pt from './pt.json'
import nlbe from './nlbe.json'

export default {
    fr,
    en, 
    es, 
    nl, 
    pt,
    nlbe
  }